export enum MARKETO_PLAN_TYPE {
    BUY = 'buy',
    TRIAL = 'trial',
}
